import PropTypes from 'prop-types';
import React, {useMemo, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {SearchUserTable} from '../../components';
import FastModal from '../../components/FastModal';
import {ModalSize} from '../../constants/dataEnum';
import './SendCopyModal.scss';

// users props: [{ _index, id, name, permission }]
const SendCopyModal = React.forwardRef(
  (
    {
      visible = false,
      users = [],
      protocolCount = 1,
      title = '',
      recipientLabel = '',
      itemLabel = '',
      recipientUnitLabel = '',
      itemUnitLabel = '',
      searchFieldPlaceholder = '',
      sendButtonLabel = '',
      cancelButtonLabel = '',
      messageLabel = '',
      showMessageLabel = '',
      sendButtonClick = () => {},
      cancelButtonClick = () => {},
      showDiscription,
      descriptionMessage,
      selectedIds,
      isOperatorOnly,
    },
    ref,
  ) => {
    const [selectedUserIds, setSelectedUserIds] = useState(selectedIds ?? []);

    useMemo(() => {
      setSelectedUserIds(selectedIds);
    }, [selectedIds]);

    const getColumn = () => {
      const column = [
        {Header: 'Name', accessor: 'name'},
        {Header: 'Role', accessor: 'role'},
      ];
      return column;
    };

    const renderContent = () => {
      const recipientCount = selectedUserIds.length;
      const noDataLabel = (
        <FormattedMessage
          id="explorer.explorerMenuBarContainer.sendProtocolModal.resultEmpty"
          values={{
            // eslint-disable-next-line react/no-unstable-nested-components
            div: (chunks) => (
              <div
                style={{
                  color: 'red',
                  padding: '30px 10px',
                }}
              >
                {chunks}
              </div>
            ),
          }}
        />
      );

      return (
        <div className="send-copy-modal" ref={ref}>
          <div className="info-row">
            <div className="info-col">
              <span>{recipientLabel}</span>
              <span>{itemLabel}</span>
            </div>
            <div className="spacer-row">&nbsp;</div>
            <div className="spacer-row">&nbsp;</div>
            <div className="spacer-row">&nbsp;</div>
            <div className="info-col">
              <span className="details">
                :{recipientCount}
                &nbsp;
                {recipientUnitLabel}
              </span>
              <span className="details">
                :{protocolCount}
                &nbsp;
                {itemUnitLabel}
              </span>
            </div>
          </div>
          {showDiscription ? (
            <div>
              <span>&nbsp;</span>
              <p>{descriptionMessage}</p>
            </div>
          ) : (
            ''
          )}
          {showMessageLabel && <div className="message-field">{messageLabel}</div>}
          <SearchUserTable
            userData={users}
            searchFieldPlaceholder={searchFieldPlaceholder}
            multiple
            selectedIdsChange={setSelectedUserIds}
            noDataLabel={noDataLabel}
            columns={getColumn()}
            selectedIds={selectedUserIds}
          />
        </div>
      );
    };

    const getProcessButtonDisabled = () => {
      if (
        selectedIds.every((ele) => selectedUserIds.includes(ele)) &&
        selectedUserIds.every((ele) => selectedIds.includes(ele))
      ) {
        return true;
      }
      if (isOperatorOnly && selectedIds.length > 0) {
        return false;
      }
      return selectedUserIds.length < 1;
    };

    const renderButtonAction = () => [
      {
        text: sendButtonLabel,
        style: 'primary',
        handlerClick: () => sendButtonClick(selectedUserIds, users),
        disabled: getProcessButtonDisabled(),
      },
      {
        text: cancelButtonLabel,
        style: 'secondary',
        handlerClick: cancelButtonClick,
      },
    ];

    return (
      <FastModal
        header={title}
        content={renderContent()}
        btnAction={renderButtonAction()}
        show={visible}
        className="send-copy"
        isValid
        closeDisabled
        size={ModalSize.MEDIUM}
      />
    );
  },
);

SendCopyModal.propTypes = {
  visible: PropTypes.bool,
  users: PropTypes.array,
  protocolCount: PropTypes.number,
  title: PropTypes.string,
  recipientLabel: PropTypes.string,
  itemLabel: PropTypes.string,
  recipientUnitLabel: PropTypes.string,
  itemUnitLabel: PropTypes.string,
  searchFieldPlaceholder: PropTypes.string,
  sendButtonLabel: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  messageLabel: PropTypes.string,
  showMessageLabel: PropTypes.string,
  sendButtonClick: PropTypes.func,
  cancelButtonClick: PropTypes.func,
  showDiscription: PropTypes.bool,
  descriptionMessage: PropTypes.string,
  selectedIds: PropTypes.array,
  isOperatorOnly: PropTypes.bool,
};

SendCopyModal.defaultProps = {
  visible: false,
  users: [],
  protocolCount: 1,
  title: '',
  recipientLabel: '',
  itemLabel: '',
  recipientUnitLabel: '',
  itemUnitLabel: '',
  searchFieldPlaceholder: '',
  sendButtonLabel: '',
  cancelButtonLabel: '',
  messageLabel: '',
  showMessageLabel: '',
  sendButtonClick: () => {},
  cancelButtonClick: () => {},
  showDiscription: false,
  descriptionMessage: '',
  selectedIds: [],
  isOperatorOnly: false,
};

export default SendCopyModal;
